import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6 max-w-3xl mx-auto text-gray-900 dark:text-gray-100">
      <Helmet>
        <title>Privacy Policy - Imagera</title>
        <meta
          name="description"
          content="This Privacy Policy outlines how Imagera collects, uses, and protects your personal data. Learn your rights and how we ensure your privacy."
        />
      </Helmet>

      <button
        onClick={() => navigate('/')}
        className="mb-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label="Back to Home"
      >
        ← Back to Home
      </button>

      <h1 className="text-4xl font-extrabold mb-8">Privacy Policy</h1>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">1. Introduction</h2>
        <p>
          At <strong>Imagera</strong>, your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our platform.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">2. Information We Collect</h2>
        <ul className="list-disc list-inside space-y-2">
          <li><strong>Personal Information:</strong> Name, email address, profile picture, and other information you provide to us.</li>
          <li><strong>Usage Data:</strong> How you interact with Imagera (likes, uploads, page views, etc.).</li>
          <li><strong>Cookies and Tracking:</strong> We use cookies and tracking technologies for functionality, preferences, and analytics.</li>
          <li><strong>Third-party services:</strong> Services like EmailJS or analytics tools may also collect limited data according to their privacy policies.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">3. How We Use Your Information</h2>
        <ul className="list-disc list-inside space-y-2">
          <li>Provide and maintain our platform’s functionality.</li>
          <li>Enhance and personalize user experience.</li>
          <li>Send updates or marketing emails (only with your consent).</li>
          <li>Detect, prevent, and address security or technical issues.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">4. Data Sharing and Disclosure</h2>
        <p>
          We do not sell your personal information. We only share it with trusted services (e.g., email delivery, analytics) or when required by law.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">5. Your Rights</h2>
        <p>
          You have the right to:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>Access and update your personal data</li>
          <li>Request deletion of your data</li>
          <li>Withdraw consent for marketing at any time</li>
        </ul>
        <p>
          To request any of the above, please contact us at <a href="mailto:hitarth0236@gmail.com" className="text-blue-600 underline">hitarth0236@gmail.com</a>.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">6. Security</h2>
        <p>
          We follow industry best practices to protect your data. However, no method is 100% secure, and we urge caution when sharing sensitive data online.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">7. Children’s Privacy</h2>
        <p>
          Imagera is not intended for children under 13. We do not knowingly collect personal data from children. If you believe a child has shared information with us, contact us immediately.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">8. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. All updates will be posted on this page with a revised effective date.
        </p>
      </section>

      <p className="text-sm text-gray-600 dark:text-gray-400">
        Last updated: June 2025
      </p>
    </div>
  );
};

export default PrivacyPolicy;